import { Controller } from '@hotwired/stimulus';

// Gère le changement d'année et l'affichage du détail dans la modale "Déclaration Assurance"
export default class extends Controller {
  static targets = ['amounts', 'details', 'detailsToggle', 'detailsIcon'];

  // Action déclenchée lors du changement d'année dans le select
  changeYear(event) {
    const selectedYear = event.target.value;

    // Récupérer tous les blocs de données par année (montants et détails)
    const yearDataBlocks = this.amountsTarget.querySelectorAll('.insurance-year-data');
    const yearDetailsBlocks = this.hasDetailsTarget
      ? this.detailsTarget.querySelectorAll('.insurance-year-details')
      : [];

    // Cacher tous les blocs et afficher seulement celui de l'année sélectionnée
    yearDataBlocks.forEach((block) => {
      block.style.display = block.dataset.year === selectedYear ? 'block' : 'none';
    });

    yearDetailsBlocks.forEach((block) => {
      block.style.display = block.dataset.year === selectedYear ? 'block' : 'none';
    });
  }

  // Action pour afficher/masquer le détail des calculs
  toggleDetails() {
    if (!this.hasDetailsTarget) return;

    const isHidden = this.detailsTarget.classList.contains('hidden');

    if (isHidden) {
      this.detailsTarget.classList.remove('hidden');
      this.detailsToggleTarget.textContent = 'Masquer le détail';
      this.detailsIconTarget.style.transform = 'rotate(180deg)';
    } else {
      this.detailsTarget.classList.add('hidden');
      this.detailsToggleTarget.textContent = 'Voir le détail des calculs';
      this.detailsIconTarget.style.transform = 'rotate(0deg)';
    }
  }
}
